import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import axios from 'axios';
import { BASE_URL, BASE_PAYMENT_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
import styles from './../../Assets/CSS/Register.module.css';
import inputStyles from './../../Assets/CSS/Input.module.css';
import { BlueButton } from './../../Components/Button';
 
function ListingCreate() {
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [isCreateLoading, setIsCreateLoading] = useState(false);
    const [category_id, setCategoryId] = useState('');
    const [sub_category_id, setSubCategoryId] = useState('');
    const [sub_sub_category_id, setSubSubCategoryId] = useState('');
    const [name, setName] = useState(''); 
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [description, setDescription] = useState('');
    const [highlight, setHighlight] = useState('');
    const [website, setWebsite] = useState('');
    const [facebook, setFacebook] = useState('');
    const [instagram, setInstagram] = useState('');
    const [house_no, setHouseNo] = useState('');
    const [road_name, setRoadName] = useState('');   
    const [pincode, setPincode] = useState('');
    const [district, setDistrict] = useState('');
    const [state, setState] = useState('');
    const [country, setCountry] = useState('');  
    const [landmark, setLandmark] = useState('');   
    const [license_no, setLicenseNo] = useState('');
    const [license_upload, setLicenseUpload] = useState(null); 
    const [category, setCategory] = useState([]);
    const [sub_category, setSubCategory] = useState([]);
    const [sub_sub_category, setSubSubCategory] = useState([]);
    useEffect(() => {
        document.title = 'Infomart | Client Listing Create';
        setIsLoading(true);
        axios.get(`${BASE_URL}/vendor/get-category`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setCategory(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }, []);
    const handleCategory = (id) => {
        setCategoryId(id);
        setSubCategory([]); 
        setSubSubCategory([]); 
        setSubCategoryId('');
        setSubSubCategoryId('');
        axios.post(`${BASE_URL}/vendor/get-sub-category`, { id }, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setSubCategory(res.data.data);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
        });
    }
    const handleSubCategory = (id) => {
        setSubCategoryId(id);
        setSubSubCategory([]); 
        setSubSubCategoryId('');
        axios.post(`${BASE_URL}/vendor/get-sub-sub-category`, { id }, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => { 
            setSubSubCategory(res.data.data);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
        });
    }
    const handleSubmit = async () => {
        setIsCreateLoading(true);
        const formData = new FormData();
        const fields = { category_id, sub_category_id, sub_sub_category_id, name, email, phone, whatsapp, description, highlight, website, facebook, instagram, house_no, road_name, pincode, district, state, country, landmark, license_no };
        Object.keys(fields).forEach(key => formData.append(key, fields[key]));
        if (license_upload) formData.append('license_upload', license_upload);
        await axios.post(`${BASE_URL}/vendor/listing/create`, formData, {
            headers: { 
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${accessToken}`
            } 
        }).then((res) => {
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsCreateLoading(false); 
            const id = res.data.id; 
            axios.post(`${BASE_URL}/vendor/listing/payment`, { id }, {
                headers: {  
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                if (res.data.encrypted_data && res.data.access_code) { 
                    const form = document.createElement('form');
                    form.method = 'post';
                    form.action = BASE_PAYMENT_URL; 
                    const encRequestInput = document.createElement('input');
                    encRequestInput.type = 'hidden';
                    encRequestInput.name = 'encRequest';
                    encRequestInput.id = 'encRequest';
                    encRequestInput.value = res.data.encrypted_data;
                    form.appendChild(encRequestInput); 
                    const accessCodeInput = document.createElement('input');
                    accessCodeInput.type = 'hidden';
                    accessCodeInput.name = 'access_code';
                    accessCodeInput.id = 'access_code';
                    accessCodeInput.value = res.data.access_code;
                    form.appendChild(accessCodeInput); 
                    document.body.appendChild(form); 
                    form.submit(); 
                }     
            }).catch((res) => {  
                toast.error(res.response.data.msg, { autoClose: 3000 }); 
            });
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsCreateLoading(false);
        });
    }
    const handlePincode = (e) => {
        let value = e.target.value;
        setPincode(value);  
        if (value.length == 6) {
            axios.get(`${BASE_URL}/pincode/${value}`).then((res) => { 
                setDistrict(res.data[0].PostOffice[0].District);
                setState(res.data[0].PostOffice[0].State);
                setCountry(res.data[0].PostOffice[0].Country); 
            });    
        }
    }  
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                        :
                        <div className={styles.individualFormContainer} style={{ width: '100%', marginBottom: 0 }}>
                            <div className={styles.top}>
                                <div className="w-100">
                                    <h4 className="text-center">Create New Listing</h4>
                                </div>
                            </div>
                            <div id="input-city" className={styles.row}>
                                <select className={inputStyles.dropdown} onChange={e => handleCategory(e.target.value)}>
                                    <option value="" selected disabled>Select Category *</option>
                                    {category.map((data, i) => (
                                        <option key={i} value={data.id}>{data.name}</option>
                                    ))}
                                </select>
                                <select className={inputStyles.dropdown} value={sub_category_id} onChange={e => handleSubCategory(e.target.value)}>
                                    <option value="" selected disabled>Select Sub Category *</option>
                                    {sub_category.map((data, i) => (
                                        <option key={i} value={data.id}>{data.name}</option>
                                    ))}
                                </select>
                                <select className={inputStyles.dropdown} value={sub_sub_category_id} onChange={e => setSubSubCategoryId(e.target.value)}>
                                    <option value="" selected disabled>Select Sub Sub Category *</option>
                                    {sub_sub_category.map((data, i) => (
                                        <option key={i} value={data.id}>{data.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div id="input-city" className={styles.row}>
                                <>
                                    <input type="text" className={inputStyles.input} placeholder="Enter Listing Name *" onChange={e => setName(e.target.value.toUpperCase())} style={{ textTransform: 'uppercase' }} />
                                    <style> 
                                        {`
                                            input::placeholder {
                                                text-transform: none;
                                            } 
                                        `}  
                                    </style> 
                                </>  
                                <input type="email" className={inputStyles.input} placeholder="Enter Email ID *" onChange={e => setEmail(e.target.value)} />
                            </div> 
                            <div id="input-city-a" className={styles.row}>
                                <input type="number" className={inputStyles.input} placeholder="Enter Phone No. *" onChange={e => setPhone(e.target.value)} />
                                <input type="number" className={inputStyles.input} placeholder="Enter WhatsApp No. *" onChange={e => setWhatsapp(e.target.value)} />
                            </div>
                            <div id="input-city" className={styles.row}>
                                <input type="text" className={inputStyles.input} placeholder="Enter Website (Optional)" onChange={e => setWebsite(e.target.value)} />
                                <input type="text" className={inputStyles.input} placeholder="Enter Facebook (Optional)" onChange={e => setFacebook(e.target.value)} />
                                <input type="text" className={inputStyles.input} placeholder="Enter Instagram (Optional)" onChange={e => setInstagram(e.target.value)} />
                            </div> 
                            <textarea className={inputStyles.input} placeholder="Enter Description *" onChange={e => setDescription(e.target.value)} />
                            <textarea className={inputStyles.input} placeholder="Enter Highlight *" onChange={e => setHighlight(e.target.value)} />
                            <div id="not-row-b" className={styles.row}> 
                                <input type="text" className={inputStyles.input} placeholder="Enter House No." onChange={e => setHouseNo(e.target.value)} />
                                <input type="text" className={inputStyles.input} placeholder="Enter Road Name *" onChange={e => setRoadName(e.target.value)} />
                            </div>  
                            <div id="not-row-b" className={styles.row}>
                                <input type="number" className={inputStyles.input} placeholder="Enter Pincode *" onChange={handlePincode} />  
                                <input type="text" className={inputStyles.input} value={district} placeholder="Enter District *" onChange={e => setDistrict(e.target.value)} />
                            </div> 
                            <div id="not-row-b" className={styles.row}>
                                <input type="text" className={inputStyles.input} value={state} placeholder="Enter State *" onChange={e => setState(e.target.value)} />
                                <input type="text" className={inputStyles.input} value={country} placeholder="Enter Country *" onChange={e => setCountry(e.target.value)} /> 
                            </div>   
                            <textarea className={inputStyles.input} placeholder="Enter Landmark (Optional)" onChange={e => setLandmark(e.target.value)} /> 
                            <input type="text" className={inputStyles.input} value={license_no} placeholder="Enter License No. (Optional)" onChange={e => setLicenseNo(e.target.value)} />
                            <input type="file" className={inputStyles.input} accept=".pdf,.jpg,.jpeg,.png" onChange={e => setLicenseUpload(e.target.files[0])} /> 
                            <div className="mt-4"> 
                                <BlueButton title={isCreateLoading ? "Loading..." : "Submit"} onClick={() => handleSubmit()} />
                            </div>
                        </div> 
                    }
                </div>
            </div> 
        </div>
    );
}

export default ListingCreate;             